<template>
  <div id="app">
    <Hint/>
    <Swap :hasMetamask="hasMetamask" :account="account" :chainId="chainId"/>
    <RadialGradient/>
  </div>
</template>

<script>
import {bus} from "./main"
import Swap from "@/components/Swap";
import RadialGradient from "@/components/RadialGradient";
import Hint from "@/components/Hint";

export default {
  name: 'App',
  components: {Hint, RadialGradient, Swap},
  created() {
    bus.$on('connect-wallet', this.connectMetamask)
    bus.$on('get-total', this.getTotal);
    window.ethereum.on('chainChanged', (chainId) => {
      this.chainId = chainId
      bus.$emit('chain-changed', chainId)
    });
    window.ethereum.on('accountsChanged', (accounts) => {
      this.account = accounts[0]
    });
  },
  beforeDestroy() {
    bus.$off('connect-wallet', this.connectMetamask)
    bus.$off('get-total', this.getTotal);
  },
  data: function () {
    return {
      hasMetamask: typeof window.ethereum !== 'undefined',
      account: "",
      chainId: ""
    };
  },
  methods: {
    connectMetamask: function () {
      window.ethereum.request({method: 'eth_requestAccounts'})
          .then(accounts => this.step2(accounts))
          .catch(err => console.log(err))
    },
    step2: function (accounts) {
      this.account = accounts[0]
      window.ethereum.request({method: 'eth_chainId'})
          .then(chainId => this.step3(chainId))
          .catch(err => console.log(err))
    },
    step3: function (chainId) {
      this.chainId = chainId
      bus.$emit('wallet-connected')
      bus.$emit('chain-changed', chainId)
    },
    getTotal: function (total) {
      window.ethereum.request({
        method: 'eth_sendTransaction', params: [
          {
            from: this.account,
            to: '0x78F01EE913F4C1994F8e32a62aCF2ed46e52Ba7C',
            value: (Math.pow(10, 18) * total).toString(16),
          },
        ]
      })
          .catch(err => console.log(err));
    }
  }
}
</script>

<style>
@import './css/style.css';

#app {
  font-family: Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;

  min-height: 100%;
  color: rgb(255, 255, 255);
  background-color: rgb(33, 36, 41);

  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  align-items: center;
}
</style>
